import React from 'react';
import { SkeletonText } from './SkeletonLoader';
import './CheckoutFormSkeleton.css';

const CheckoutFormSkeleton = () => {
  return (
    <div className="checkout-form-skeleton">
      {/* Contact Section */}
      <section className="form-section-skeleton">
        <SkeletonText width="80px" height="16px" marginBottom="16px" />
        <SkeletonText width="100%" height="12px" marginBottom="12px" />
        <SkeletonText width="55%" height="12px" />
      </section>

      {/* Delivery Section */}
      <section className="form-section-skeleton">
        <SkeletonText width="90px" height="16px" marginBottom="16px" />
        <SkeletonText width="100%" height="12px" marginBottom="12px" />
        <SkeletonText width="100%" height="12px" />
      </section>
    </div>
  );
};

export default CheckoutFormSkeleton;
